export default function loginHeader () {
 
  return {
    'ApiKey': process.env.VUE_APP_APIKEY
  }
}